import React from 'react';

import { Box, Divider } from '@material-ui/core';
import { FormProvider } from 'react-hook-form';

import { AppAccordion } from '@vyce/core/src/components/AppAccordion';
import { AppButton } from '@vyce/core/src/components/AppButton';
import { SettingsCard } from '@vyce/core/src/components/SettingsCard';

import { Props } from './types';
import { useData } from './hooks/useData';
import { AppCheckbox } from '../../../components/inputs';
import { LocationAndShiftControlBlock } from './components/LocationAndShiftControlBlock';
import { RulesWrapper } from './components/RulesWrapper';
import { ApplyToAllShiftButton } from './components/ApplyToAllShiftButton';
import { RestoreShiftRules } from './components/RestoreShiftRules';

export const TimeRules = (props: Props) => {
  const {
    methods,
    locations,
    shifts,
    shiftRuleSchemas,
    selectedRules,
    isButtonDisabled,
    handleSubmit,
    handleChangeSelectedRules,
    updateRulesForAllShifts,
    handleDeleteRules,
  } = useData(props);

  return (
    <FormProvider {...methods}>
      <SettingsCard
        title="Bonuses and deductions"
        description="Rules Vyce applies to paid hours automatically — for example, drop paid breaks when a shift runs short, or add a bonus for completing a full day. Set them per location and shift."
        status={
          selectedRules.length
            ? `${selectedRules.length} ${selectedRules.length === 1 ? 'rule' : 'rules'} on`
            : 'No rules on'
        }
        statusTone={selectedRules.length ? 'on' : 'off'}
        expanded={props.expanded}
        onExpandedChange={props.onExpandedChange}
        secondaryAction={
          <Box display="flex" alignItems="center" gridGap={16} flexWrap="wrap">
            <ApplyToAllShiftButton handleConfirm={updateRulesForAllShifts} />
            <RestoreShiftRules handleConfirm={handleDeleteRules} />
          </Box>
        }
        actions={
          <AppButton variant="contained" color="primary" disabled={isButtonDisabled} onClick={handleSubmit}>
            Save changes
          </AppButton>
        }
      >
        <LocationAndShiftControlBlock locations={locations} shifts={shifts} />

        <Box display="flex" flexDirection="column">
          {shiftRuleSchemas?.map((item, index) => (
            <React.Fragment key={item.uuid}>
              {index > 0 && <Divider />}

              <Box
                display="flex"
                alignItems="baseline"
                gridGap={8}
                paddingTop={index === 0 ? 0 : 2}
                paddingBottom={index === shiftRuleSchemas.length - 1 ? 0 : 2}
              >
                <AppAccordion
                  title={item.name}
                  noPadding
                  renderExtraControl={() => (
                    <AppCheckbox
                      checked={selectedRules.includes(item.uuid)}
                      onChange={() => handleChangeSelectedRules(item.uuid)}
                      variant="rectangle"
                      color="primary"
                    />
                  )}
                  renderDetailsBlock={() => <RulesWrapper {...item} />}
                />
              </Box>
            </React.Fragment>
          ))}
        </Box>
      </SettingsCard>
    </FormProvider>
  );
};
